<!--
* @Author: DY
* @Date: 2020年11月26日19:21:55
* @Description: 添加送货车辆（原材料管理-供应单台账）
-->
<template>
    <div class="addDeliveryVehicles" v-loading="loading">
        <div class="content_box">
            <table>
                <tbody>
                    <tr>
                        <th><i>*</i>车牌号码</th>
                        <td colspan="3">
                            <el-input v-model="addData.car_no" placeholder="请输入车牌号码"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <th><i>*</i>司机姓名</th>
                        <td>
                            <el-input v-model="addData.driver_name" placeholder="请输入司机姓名"></el-input>
                        </td>
                        <th><i>*</i>司机电话</th>
                        <td>
                            <el-input v-model="addData.driver_phone" placeholder="请输入司机电话"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <th>备注</th>
                        <td colspan="3">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 2 }"
                                placeholder="请填写备注"
                                v-model="addData.remarks"
                            >
                            </el-input>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <footer>
            <el-button @click="cancel">
                取消
            </el-button>
            <el-button type="primary" @click="confirm">
                确认
            </el-button>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'add-delivery-vehicles',
    components: {},
    props: {
        extr: {
            type: [Object],
        },
    },
    data() {
        return {
            addData: {
                // 车牌号
                car_no: '',
                // 司机姓名
                driver_name: '',
                // 司机手机号
                driver_phone: '',
                // 备注
                remarks: '',
            },
            loading: false,
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {
        // 取消
        cancel() {
            this.$parent.hide();
        },
        // 确认添加
        confirm() {
            if (this.addData.car_no === '') {
                this.$message({
                    message: '请填写车牌号！',
                    type: 'warning',
                });
            } else if (this.addData.driver_name === '') {
                this.$message({
                    message: '请填写司机姓名！',
                    type: 'warning',
                });
            } else if (this.addData.driver_phone === '') {
                this.$message({
                    message: '请填写司机手机号！',
                    type: 'warning',
                });
            } else {
                this.loading = true;
                const poatData = Object.assign(this.addData, this.extr.requestParameters);
                this.$axios
                    .post(this.extr.url, poatData)
                    .then(() => {
                        this.$message({
                            message: '添加成功！',
                            type: 'success',
                        });
                        this.$parent.hide();
                        this.extr.refreshTable();
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                        this.$message.error(error.ErrorCode.Message);
                    });
            }
        },
    },
};
</script>

<style lang="stylus">
.addDeliveryVehicles
    height 100%
    padding 15px
    position relative
    .content_box
        height calc(100% - 60px)
        overflow-y auto
        table
            width 100%
            border-collapse collapse
            th,td
                line-height 40px
                font-size 16px
                border 1px solid #D7D7D7
            th
                background-color #F6F8FC
                color: #002B94
                font-weight normal
                padding-left 20px
                i
                    color red
            td
                .el-input__inner
                    height 40px
                    line-height 40px
    footer
        width 100%
        position absolute
        bottom 20px
        left 0
        text-align center
        .el-button
            width 150px
            padding 0
            font-size 16px
            line-height 40px
            margin 0 20px
            height 40px
</style>

